import { SessionEventType } from './session-event-type.model';

export class CreateSessionEventDto {
  constructor(
    public type: SessionEventType
  ) { }
}
